import bannerMob from "../assets/img/mobile.webp";
import bannerDsk from "../assets/img/desktop.webp";

export const GENERIC_LANDING_CONFIG = {
  firebaseDocId: "evento-territory-everest-2026",
  eventName: "Territory y Everest Day",
  introSubtitle: "Agendá tu test drive y manejá el modelo que tenés en la mira.",
  emailEventName: "Territory y Everest Day - Test Drive Montironi",
  emailjsTemplateId:
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID_TERRITORY || process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
  marcaSeleccionada: "Ford",
  tipoFormulario: "territory-everest",
  banners: {
    mobile: bannerMob,
    desktop: bannerDsk,
  },
};
